import { Box } from '@mui/material';
import BuildIcon from '@mui/icons-material/Build';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { useSelectedWorkshop } from '../../context/workshopContext';
import useComponentVisible from '../../hooks/useComponentVisible';

const WorkshopSelector = () => {
  const { workshops, selectedWorkshop, selectedOrganisationId, setSelectedOrganisationId, isLoading } =
    useSelectedWorkshop();
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  if (isLoading || !selectedWorkshop) {
    return null;
  }

  return (
    <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', height: '100%' }}>
      <Box ref={ref} sx={{ position: 'relative', display: 'flex', alignItems: 'center', height: '100%' }}>
        <Box
          component="button"
          onClick={() => setIsComponentVisible(!isComponentVisible)}
          aria-haspopup="listbox"
          aria-expanded={isComponentVisible}
          sx={{
            display: 'flex',
            alignItems: 'center',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: 'white',
            fontFamily: 'inherit',
            padding: 0,
            textAlign: 'left',
          }}
        >
          <BuildIcon sx={{ fontSize: 20, marginRight: 0.75 }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.15 }}>
            <Box sx={{ fontSize: 18, fontWeight: 400 }}>
              {selectedWorkshop.organisationName}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 21 }}>
            {isComponentVisible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </Box>
        </Box>

        {isComponentVisible && (
          <Box
            role="listbox"
            sx={{
              position: 'absolute',
              top: '100%',
              right: 0,
              minWidth: 200,
              zIndex: 40,
            }}
          >
            {workshops.map((workshop, index) => {
              const isSelected = workshop.organisationId === selectedOrganisationId;

              return (
                <Box
                  key={workshop.organisationId}
                  role="option"
                  aria-selected={isSelected}
                  onMouseDown={() => {
                    setSelectedOrganisationId(workshop.organisationId);
                    setIsComponentVisible(false);
                  }}
                  sx={{
                    backgroundColor: 'rgba(0,0,0,0.73)',
                    borderBottomLeftRadius: index === workshops.length - 1 ? 6 : 0,
                    borderBottomRightRadius: index === workshops.length - 1 ? 6 : 0,
                    color: 'white',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontWeight: isSelected ? 600 : 400,
                    whiteSpace: 'nowrap',
                    transition: 'filter 200ms ease-in-out',
                    '&:hover': {
                      filter: 'brightness(110%)',
                    },
                  }}
                >
                  {workshop.organisationName}
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default WorkshopSelector;
